import { useIsMobile } from 'src/app/shared/hooks/userAgent';

export function useInstagramAvailable(): boolean {
	return useIsMobile();
}
